import { Injectable } from '@angular/core';
import { DataService } from '../data.service';

@Injectable({
  providedIn: 'root',
})
export class CentersService {
  private readonly endPoint = '/centers';

  constructor(private dataService: DataService) {}

  async getPaymentMethodIds(centerId: number): Promise<number[]> {
    return await this.dataService
      .get<number[]>(`${this.endPoint}/${centerId}/payment-method-ids`)
      .toPromise();
  }
}
